import React from "react";
import ProgressBar from 'react-bootstrap/ProgressBar';

let uid = 0;
let pending_tests = [];
let succedded = 0;
let failed = 0;

async function test_lookup_dealer(logicalId) {
  let test = {
    id: uid++,
    name: `Load data for dealer ${logicalId}`,
  };
  console.log(test.name);
  try {
    let response = await fetch(`/api/ews-lookup/${logicalId}`);
    let dealer_data = await response.json();
    pending_tests.push(() => {return test_get_cvi_vehicles(dealer_data.platformId)});
    pending_tests.push(() => {return test_get_vauto_vehicles(dealer_data.id)});
    test.success = dealer_data.name;
  } catch (e) {
    test.error = e.toString();
  }
  return test;
}

async function test_get_cvi_vehicles(entityId) {
  let test = {
    id: uid++,
    name: `Load CVI vehicles for entity ${entityId}`,
    error: null
  };
  console.log(test.name);
  try {
    let response = await fetch(`/api/cvi-vehicle-list/${entityId}`);
    let vehicles = await response.json();
    test.success = `${vehicles.length} vehicles`;
    pending_tests.push(() => {return test_get_cvi_vehicle(entityId, vehicles[0].id)});
  } catch (e) {
    test.error = e.toString();
  }
  return test;
}

async function test_get_vauto_vehicles(dealerId) {
  let test = {
    id: uid++,
    name: `Load vAuto vehicles for dealer ${dealerId}`,
    error: null
  };
  console.log(test.name);
  try {
    let response = await fetch(`/api/vauto-vehicle-list/${dealerId}`);
    let vehicles = await response.json();
    test.success = `${vehicles.length} vehicles`;
    pending_tests.push(() => {return test_get_vauto_vehicle(vehicles[0].id)});    
  } catch (e) {
    test.error = e.toString();
  }
  return test;
}

async function test_get_vauto_vehicle(vehicleId) {
  let test = {
    id: uid++,
    name: `Get vAuto vehicle details for ${vehicleId}`,
    error: null
  };
  console.log(test.name);
  try {
    let response = await fetch(`/api/vauto-vehicle/${vehicleId}`);
    let v = await response.json();
    test.success = `${v.vin}: ${v.modelYear} ${v.make} ${v.model} ${v.series}`;
  } catch (e) {
    test.error = e.toString();
  }
  return test;
}

async function test_get_cvi_vehicle(entityId, vehicleId) {
  let test = {
    id: uid++,
    name: `Get CVI vehicle details for ${vehicleId}`,
    error: null
  };
  console.log(test.name);
  try {
    let response = await fetch(`/api/cvi-vehicle/${entityId}/${vehicleId}`);
    let v = await response.json();
    test.success = `${v.dealerVehicle.vin}: ${v.dealerVehicle.description.year} ${v.dealerVehicle.description.make} ${v.dealerVehicle.description.model.normalizedName} ${v.dealerVehicle.description.trim.normalizedName}`;
  } catch (e) {
    test.error = e.toString();
  }
  return test;
}

function TestResult(props) {
  let color = props.test.success ? "green" : "red";
  return <div style={{color: color}}>&gt; {props.test.name} - {props.test.success ?? props.test.error}</div>
}

function SmokeTests() {
  const [testResults, setTestResults] = React.useState([]);
  const [progressSuccess, setProgressSuccess] = React.useState(0);
  const [progressFailed, setProgressFailed] = React.useState(0);

  async function runNextTest() {
    setProgressSuccess(succedded / (pending_tests.length + succedded + failed) * 100.0);
    setProgressFailed(failed / (pending_tests.length + succedded + failed) * 100.0);
    if (pending_tests.length > 0) {
      let result = await pending_tests.shift()();
      setTestResults(old => [result, ...old]);
      if (result.success) succedded++;
      else failed++;
      setTimeout(runNextTest, 1);
    }
  }

  function startTests() {
    pending_tests.push(() => {return test_lookup_dealer("MP5020")});
    pending_tests.push(() => {return test_lookup_dealer("MP5077")});
    runNextTest();
  }

  return <div style={{ margin: 20 }}>
    <h1>Smoke Tests</h1>
    <button onClick={startTests}>Start Tests</button>
    <hr />
    <ProgressBar>
      <ProgressBar variant="success" now={progressSuccess} key={1} />
      <ProgressBar variant="danger" now={progressFailed} key={2} />
    </ProgressBar>    
    {testResults.map((r) => <TestResult key={r.id} test={r} />)}
  </div>
}

export default SmokeTests;